import { Tooltip } from "@mui/material";
import DarkModeCopyIcon from "assets/img/svg/darkModeCopyIcon.svg?react";
import React, { useState } from "react";
import { fallbackCopyTextToClipboard } from "../../utils";
import "./styles.scss";

interface CopyButtonProps {
  className?: string;
  disabled?: boolean;
  displayValue?: string;
  onClick?: () => void;
  value: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  className = "",
  disabled,
  displayValue,
  onClick,
  value,
}) => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    if (disabled) return;
    fallbackCopyTextToClipboard(value);
    setClicked(true);
    onClick?.();
    setTimeout(() => {
      setClicked(false);
    }, 1000);
  };

  return (
    <div
      className={`${className} flex gap-2`}
    >
      <Tooltip open={clicked} title="Copied to clipboard!">
        <button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          title="Copy to clipboard"
        >
          <DarkModeCopyIcon className={`CopyButton-Icon ${ clicked ? "CopyButton-IconClicked" : ""}`} />
        </button>
      </Tooltip>
      <div>{displayValue || value }</div>
    </div>
  );
};

export default CopyButton;
